import { lazy } from "react";

const Home = lazy(() => import("../Pages/Home"));
const Shop = lazy(() => import("../Pages/Shop"));
const ShopDetails = lazy(() => import("../Pages/ShopDetails"));
const ShoppingCart = lazy(() => import("../Pages/ShoppingCart"));
const Checkout = lazy(() => import("../Pages/Checkout"));
const UserProfile = lazy(() => import("../Pages/UserProfile/UserProfile"));
const Wishlist = lazy(() => import("../Pages/Wishlist"));
const TermsAndCondition = lazy(() =>
  import("../Pages/Policy/TermsAndCondition")
);
const PrivacyPolicy = lazy(() => import("../Pages/Policy/PrivacyPolicy"));
const ReturnAndRefund = lazy(() => import("../Pages/Policy/ReturnAndRefund"));
const ShippingPolicy = lazy(() => import("../Pages/Policy/ShippingPolicy"));
const ContactUs = lazy(() => import("../Pages/ContactUs"));
const AdministrationLogin = lazy(() => import("../Pages/Administration/Login"));
const AdministrationDashboard = lazy(() =>
  import("../Pages/Administration/Dashboard")
);
const ProductList = lazy(() =>
  import("../Pages/Administration/Product/ProductList")
);
const AddProduct = lazy(() =>
  import("../Pages/Administration/Product/AddProduct")
);
const EditProduct = lazy(() =>
  import("../Pages/Administration/Product/EditProduct")
);
const PromocodeList = lazy(() =>
  import("../Pages/Administration/Promocode/PromocodeList")
);
const UserList = lazy(() => import("../Pages/Administration/User/UserList"));
const MessageList = lazy(() =>
  import("../Pages/Administration/Message/Message")
);
const DeleteRequestList = lazy(() =>
  import("../Pages/Administration/DeleteRequest/DeleteRequestList")
);
const RefundRequestList = lazy(() =>
  import("../Pages/Administration/RefundRequest/RefundRequestList")
);
const NewsLetterList = lazy(() =>
  import("../Pages/Administration/NewsLetter/NewsLetterList")
);
const NotificationList = lazy(() =>
  import("../Pages/Administration/Notification/NotificationList")
);
const SliderList = lazy(() =>
  import("../Pages/Administration/Slider/SliderList")
);
const CategoryList = lazy(() =>
  import("../Pages/Administration/Category/CategoryList")
);
const SubCategoryList = lazy(() =>
  import("../Pages/Administration/SubCategory/SubCategoryList")
);
const CollectionList = lazy(() =>
  import("../Pages/Administration/Collection/CollectionList")
);
const StylingList = lazy(() =>
  import("../Pages/Administration/Styling/StylingList")
);
const NewArrivalList = lazy(() =>
  import("../Pages/Administration/NewArrival/NewArrivalList")
);
const OrderList = lazy(() => import("../Pages/Administration/Order/OrderList"));
const OrderDetails = lazy(() => import("../Pages/OrderDetails"));
const AdministrationOrderDetails = lazy(() =>
  import("../Pages/Administration/Order/OrderDetails")
);
const publicRoutes = [
  { path: "/", component: <Home /> },
  { path: "/shop", component: <Shop /> },
  { path: "/product-details/:id", component: <ShopDetails /> },
  { path: "/cart", component: <ShoppingCart /> },
  { path: "/checkout", component: <Checkout /> },
  { path: "/wishlist", component: <Wishlist /> },
  { path: "/terms-and-conditions", component: <TermsAndCondition /> },
  { path: "/privacy-policy", component: <PrivacyPolicy /> },
  { path: "/return-and-refund", component: <ReturnAndRefund /> },
  { path: "/shipping-policy", component: <ShippingPolicy /> },
  { path: "/contact-us", component: <ContactUs /> },
];

const protectedRoutes = [
  {
    path: "/userprofile/*",
    component: <UserProfile />,
  },
  { path: "/order-details", component: <OrderDetails /> },
];

const adminRoutesPublic = [
  { path: "/administration", component: <AdministrationLogin /> },
];
const adminRoutesProtected = [
  { path: "/administration/dashboard", component: <AdministrationDashboard /> },
  { path: "/administration/product", component: <ProductList /> },
  { path: "/administration/add-product", component: <AddProduct /> },
  { path: "/administration/edit-product", component: <EditProduct /> },
  { path: "/administration/promocode", component: <PromocodeList /> },
  { path: "/administration/user", component: <UserList /> },
  { path: "/administration/message", component: <MessageList /> },
  { path: "/administration/delete-request", component: <DeleteRequestList /> },
  { path: "/administration/refund-request", component: <RefundRequestList /> },
  { path: "/administration/newsletter", component: <NewsLetterList /> },
  { path: "/administration/notification", component: <NotificationList /> },
  { path: "/administration/slider", component: <SliderList /> },
  { path: "/administration/category", component: <CategoryList /> },
  { path: "/administration/subcategory", component: <SubCategoryList /> },
  { path: "/administration/collection", component: <CollectionList /> },
  { path: "/administration/styling", component: <StylingList /> },
  { path: "/administration/new-arrivals", component: <NewArrivalList /> },
  { path: "/administration/order", component: <OrderList /> },
  {
    path: "/administration/order-details",
    component: <AdministrationOrderDetails />,
  },
];

export {
  protectedRoutes,
  publicRoutes,
  adminRoutesPublic,
  adminRoutesProtected,
};
